module.exports = __webpack_public_path__ + "static/media/ellipse.6fcf097d.svg";